import React, { Component } from "react";
import { connect } from "react-redux";
import { Segment, Grid } from "semantic-ui-react";
import AppMenu from "../../components/pages/AppMenu";
import api from "../../api";
import { expireSession } from "../../actions/auth";
import { getMySearchesBreadcrumb } from "../common/Breadcrumb";
import UserProfileForm from "../forms/UserProfileForm";
import MessageModel from "../dialogs/MessageModel";

class MyProfile extends Component {
  state = {
    statusProps: {
      open: false,
      size: "mini",
      title: "My Profile",
      message: "Profile updated successfully!",
    },
    showSuccessMessage: false,
    showFaileMessage: false,
    loading: false,
  };
  submit = (data) => {
    this.setState({ loading: true });
    api.user
      .userProfileUpdate(
        this.props.user.userid,
        data.themeOption ? 1 : 0,
        data.searchBySsn ? 1 : 0
      )
      .then((res) => {
        if (res.status === 200) {
          this.setState({ showSuccessMessage: true, showFaileMessage: false });
        } else {
          this.setState({ showFaileMessage: true, showSuccessMessage: false });
        }
        this.setState({ loading: false });
      })
      .catch((err) => {
        console.log("profile update error - ", err);
        this.setState({ showFaileMessage: true, showSuccessMessage: false });
        if (err.response && err.response.status === 401) {
          this.props.expireSession();
        }
        this.setState({ loading: false });
      });
  };

  render() {
    const { showFaileMessage, showSuccessMessage } = this.state;
    return (
      <div className="container-fluid">
        <div className="padding-top-20" />
        <AppMenu
          uiData={this.props.uiData}
          userAccount={this.props.userAccount}
          history={this.props.history}
          onMouseOver={this.handleMouseOver}
        />
        <div>
          <Segment>
            {getMySearchesBreadcrumb({
              currentPage: "My Profile",
              history: this.props.history,
            })}
            <br />
            {showSuccessMessage && (
              <p className="success-message">
                Please logout and login back to see the update.
              </p>
            )}
            {showFaileMessage && (
              <p className="failed-message">
                Unable to update profile. Please contact administrator.
              </p>
            )}
            <Grid stackable className="padding-left-20">
              <Grid.Row>
                <Grid.Column>
                  <UserProfileForm
                    {...this.props}
                    submit={this.submit}
                    loading={this.state.loading}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
            {MessageModel(this.state.statusProps)}
          </Segment>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    uiData: state.uiData,
    userAccount: state.userAccount,
  };
}

export default connect(mapStateToProps, { expireSession })(MyProfile);



// WEBPACK FOOTER //
// ./src/components/myaccount/MyProfile.js